
































































import { EmployeApi } from "../api/EmployeApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import FraisPdf from "../trajet/FraisPdf.vue";
import moment from "moment";

export default {
    name: "NotesDeFraisList",
    components: { FraisPdf },
    props: {
        employeId: Number,
    },
    data() {
        return {
            notesDeFrais: [],
            year: moment().year(),
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        this.refreshNotesDeFrais();
    },
    methods: {
        refreshNotesDeFrais() {
            let self = this;
            if (this.employeId)
                this.EmployeApi.getNotesDeFrais(this.employeId).then(function (
                    res
                ) {
                    self.notesDeFrais = res;
                });
        },
        deleteNoteDeFrais(noteDeFrais) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cette note de frais ?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.EmployeApi.removeNoteDeFrais(
                    self.employeId,
                    noteDeFrais.month,
                    raison
                )
                    .then(function () {
                        self.refreshNotesDeFrais();
                    })
                    .catch(function () {
                        swal(
                            "La note de frais n'a pas pu être supprimée.",
                            "",
                            "error"
                        );
                    });
            });
        },
        filteredNotesDeFrais() {
            let self = this;
            return _.filter(this.notesDeFrais, function (noteDeFrais) {
                return noteDeFrais.month.year == self.year;
            });
        },
        totalAnnee() {
            let self = this;
            return _.reduce(
                self.filteredNotesDeFrais(),
                function (total, noteDeFrais) {
                    return total + noteDeFrais.total;
                },
                0
            );
        },
    },
};
